<template>
    <div>
        <div class="content bg-gray-lighter ng-scope">
            <div class="row items-push">
                <div class="col-sm-10">
                    <h1 class="page-heading">
                        Specifiche approvate
                    </h1>
                </div>
            </div>
        </div>

        <div class="content">
            <!-- Dynamic Table Full -->
            <div class="block">
                <div class="block-content block-content-full">
                    <div class="row" style="margin-bottom:20px">
                        <div class="col-sm-12 col-md-6">
                            <label class="form-material">Seleziona Perito</label>
                                <SelettoreRicerca
                                    type="all"
                                    placeholder="Seleziona un Perito"
                                    voidText="Nessun perito trovato"
                                    :selectedModel="ispettoreSelected"
                                    @updateSelector="updateSelector"
                                />
                        </div>
                    </div>
                    <div class="row" style="margin-bottom:20px">
                        <div class="col-sm-12 col-md-6">
                            <label class="form-material">Seleziona Grado</label>
                                <select v-model="gradoSelected" class="form-control" name="grade">
                                    <option value>Seleziona Grado Utente</option>
                                    <option v-for="grade in grades" :key="grade.id" :value="grade.id">{{grade.name}}</option>
                                </select>
                        </div>
                    </div>
                    <div class="row" style="margin-bottom:20px;">
                        <div class="col-sm-12 col-md-6">
                            <div class="dataTables_length" id="DataTables_Table_0_length">
                                <label>
                                    <select v-model="search.per_page" @change="perPage" name="DataTables_Table_0_length" class="form-control form-control-sm">
                                        <option value="10">10</option>
                                        <option value="20">20</option>
                                        <option value="50">50</option>
                                    </select>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div v-if="specifiche.length == 0" class="row">
                        <div class="col-md-12" style="text-align:center;padding:20px 0px;">
                            <h4>Nessuna specifica presente.</h4>
                        </div>
                    </div>
                    <table v-if="specifiche.length > 0" class="table table-bordered table-striped js-dataTable-full dataTable">
                        <thead>
                            <tr>
                                <ThTable @updateOrder="orderBy" orderKey="id" name="#ID" :orderBy="search.orderBy" />
                                <ThTable @updateOrder="orderBy" orderKey="data_specifica" name="DATA" :orderBy="search.orderBy" />
                                <ThTable @updateOrder="orderBy" orderKey="codice_perito" name="COD. PERITO" :orderBy="search.orderBy" />
                                <ThTable @updateOrder="orderBy" orderKey="onorario" name="ONORARIO" :orderBy="search.orderBy" />
                                <ThTable @updateOrder="orderBy" orderKey="vitto" name="VITTO" :orderBy="search.orderBy" />
                                <ThTable @updateOrder="orderBy" orderKey="alloggio" name="ALLOGGIO" :orderBy="search.orderBy" />
                                <ThTable @updateOrder="orderBy" orderKey="km_totali" name="KM TOTALI" :orderBy="search.orderBy" />
                                <th class="d-none d-sm-table-cell">DETTAGLI</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(specifica, index) in specifiche" :key="index">
                                <td class="font-size-sm">
                                    {{specifica.id}}
                                </td>
                                <td class="font-size-sm">
                                    {{data_specifica(specifica.data_specifica)}}
                                </td>
                                <td class="font-size-sm">
                                    {{specifica.perito.codice_perito}} - {{specifica.perito.name}} {{specifica.perito.surname}}
                                </td>
                                <td class="d-none d-sm-table-cell font-size-sm">
                                     {{specifica.onorario}}
                                </td>
                                <td class="d-none d-sm-table-cell font-size-sm">
                                     {{specifica.vitto}}
                                </td>
                                <td class="d-none d-sm-table-cell font-size-sm">
                                     {{specifica.alloggio}}
                                </td>
                                <td class="d-none d-sm-table-cell font-size-sm">
                                     {{specifica.km_residenza + specifica.km_perizia}}
                                </td>
                                <td class="d-none d-sm-table-cell font-size-sm">
                                    <div class="btn-group">
                                        <button @click="showModalView(specifica)" type="button" class="btn btn-sm btn-light" data-toggle="tooltip" title="Edit Perizia">
                                            <i class="fa fa-fw fa-eye"></i>
                                        </button>
                                        <button @click="compareSpecifica(specifica)" type="button" :class="['btn btn-sm', specifica.selected ? 'btn-success':'btn-light']" data-toggle="tooltip" title="Compare Specifica">
                                            <i class="fas fa-arrows-alt-h"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <Pagination :show="specifiche.length > 0" v-model="search.page" :lastPage="data.last_page" @paginateClick="paginateClick" />
                    <ComparaSpecifiche ref="compara_specifiche"></ComparaSpecifiche>
                </div>
            </div>
        </div>
        
        <ModalSpecifica ref="modal_specifica" 
            :ispettori_int="ispettori"
            :consorzi_int="consorzi"
            :agenzie_int="agenzie" 
            :specifica="selected_specifica"
            :isModalVisible="isModalVisible" 
            @closeModalCallback="close_modal_callback" />


    </div>
</template>

<script>
import ModalSpecifica from "../../components/Specifiche/ModalSpecifica"
import ComparaSpecifiche from "../../components/Specifiche/ComparaSpecifiche"
import ThTable from '../../components/ThTable'
import SpecificaRepository from "../../services/apis/specifica"
import UtilityRepository from "../../services/apis/utility"
import UserRepository from "../../services/apis/user"
import SelettoreRicerca from "../../components/SelettoreRicerca"
import Pagination from "../../components/Pagination/Pagination"
export default {
    components: {
        ThTable, ModalSpecifica, ComparaSpecifiche, SelettoreRicerca, Pagination
    },
    data(){
        return {
            specifiche:[],
            data: {
                last_page:1
            },
            search: {
                status:1,
                per_page: 10,
                page:1,
                orderBy:'data_specifica:desc'
            },
            ispettori:[],
            consorzi:[],
            agenzie:[],
            grades:[],
            selected_specifica:null,
            isModalVisible:false,
            ispettoreSelected:null,
            gradoSelected:null,
        }
    },
    watch: {
        'ispettoreSelected': function() {
            this.search.page = 1
            this.get_specifiche()
        },
        'gradoSelected': function() {
            this.search.page = 1
            this.get_specifiche()
        }
    },
    methods: {
        updateSelector(type, item){
            if(type == 'all'){
                this.ispettoreSelected = item
            }
        },
        orderBy(_orderBy){
            this.search.orderBy = _orderBy
            this.get_specifiche()
        },
        async get_lista_ispettori(){
            let _resp = await SpecificaRepository.get_lista_ispettori().catch(() => {})

            if(_resp){
                this.ispettori = _resp.data.data
            }
            
        },
        async get_consorzi(){
            let _resp = await UtilityRepository.search_consorzi('').catch(()=> {})
            
            if(_resp){
                this.consorzi = _resp.data.data
            }
        },
        async get_agenzie(){
            let _resp = await UtilityRepository.search_agenzie('').catch(()=> {})

            if(_resp){
                this.agenzie = _resp.data.data
            }
        },
        async get_specifiche(){
            this.search.perito_id = this.ispettoreSelected ? this.ispettoreSelected.id : ""
            this.search.grado_id = this.gradoSelected ? this.gradoSelected : ""
            const _resp = await SpecificaRepository.filtrate_per_status(this.search).catch(() => {})
            
            if(_resp){
                this.specifiche = _resp.data.data.data
                this.data = _resp.data.data
            }
        },
        async get_grades(){
            let _resp = await UserRepository.grades().catch(()=> {})

            if(_resp){
                this.grades = _resp.data.data
            }
        },
        data_specifica(data){
            return data ? this.$moment(data).format('DD-MM-YYYY') : ''
        },
        perPage(){
            this.search.page = 1
            this.get_specifiche()
        },
        paginateClick(){
            this.get_specifiche()
        },
        showModalView(specifica){
            this.selected_specifica = specifica
            this.isModalVisible = true
        },
        close_modal_callback(){
            this.isModalVisible = false
            this.selected_specifica = null
        },
        compareSpecifica(specifica){
            this.$refs.compara_specifiche.compara(specifica)
            this.$forceUpdate();
        }
    },
    created(){
        this.get_lista_ispettori()
        this.get_consorzi()
        this.get_agenzie()
        this.get_specifiche()
        this.get_grades()
    }
}
</script>

